import axios from 'axios';
import { selectHasPayPassword, selectUserAuth, checkUserCancelStatus, selectCustomerAuth } from '../axios/api'
import { ElMessage, ElMessageBox } from "element-plus";
import { useMainStore } from '../pinia/main';
import { h } from 'vue'

//验证手机号
export function isPhoneNumber(phoneNum) {
    var pattern = /^1[3456789]\d{9}$/;
    return pattern.test(phoneNum);
}

//手机号脱敏
export const phoneDesc = (phone) => {
    return isPhoneNumber(phone) ?
        phone.replace(/(\d{3})\d*(\d{4})/, '$1****$2') :
        EncryptName(phone);
}

export const EncryptName = (name) => {
    if (!name) return "";
    let newStr;
    if (name.length === 2) {
        newStr = name.substr(0, 1) + '*';
    } else if (name.length > 2) {
        let char = '';
        for (let i = 0, len = name.length - 2; i < len; i++) {
            char += '*';
        }
        newStr = name.substr(0, 1) + char + name.substr(-1, 1);
    } else {
        newStr = name;
    }

    return newStr;
}
//校验身份证id
export const checkIdCard = (idcard) => {
    var area = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外"
    }
    var idcard, Y, JYM;
    var S, M;
    var idcard_array = new Array();
    idcard_array = idcard.split("");
    //地区检验 
    if (area[parseInt(idcard.substr(0, 2))] == null) return false;
    //身份号码位数及格式检验 
    switch (idcard.length) {
        case 15:
            if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || ((parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0)) {
                ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; //测试出生日期的合法性 
            } else {
                ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; //测试出生日期的合法性 
            }
            if (ereg.test(idcard)) {
                return true;
            }
            else {
                return false;
            }
        case 18:
            if (parseInt(idcard.substr(6, 4)) % 4 == 0 || (parseInt(idcard.substr(6, 4)) % 100 == 0 && parseInt(idcard.substr(6, 4)) % 4 == 0)) {
                ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/; //闰年出生日期的合法性正则表达式 
            } else {
                ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/; //平年出生日期的合法性正则表达式 
            }
            if (ereg.test(idcard)) { //测试出生日期的合法性 
                //计算校验位 
                S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) * 1 + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
                Y = S % 11;
                M = "F";
                JYM = "10X98765432";
                M = JYM.substring(Y, 1); //判断校验位 
                if (M == idcard_array[17]) return true; //检测ID的校验位 
                else return false;
            } else return false;
        default:
            return false;
    }
};

//银行卡脱敏
export const desensitizeCardNumber = (cardNumber) => {
    // 获取银行卡号长度
    const length = cardNumber.length;
    // 如果银行卡号长度小于等于4，则无需脱敏，直接返回原始银行卡号
    if (length <= 4) return cardNumber;
    // 取出前四位
    const firstTwo = cardNumber.substring(0, 2);
    // 取出后四位
    const lastFour = cardNumber.substring(length - 4);
    // 构造脱敏字符串，中间的数字用 "*" 替换
    const middle = "*".repeat(length - 6);
    // 组合成脱敏后的银行卡号
    const desensitizedCardNumber = firstTwo + middle + lastFour;
    return desensitizedCardNumber;
}

//计算两个时间之间相差的天数
export const getDiffDay = (date_1, date_2) => {
    let totalDays, diffDate
    let myDate_1 = Date.parse(date_1)
    let myDate_2 = Date.parse(date_2)
    diffDate = Math.abs(myDate_1 - myDate_2)
    totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
    return totalDays
}

//数字转化为K，W
export const formatNumber = (num = "") => {
    if (num >= 1000 && num < 10000) {
        return (num / 1000).toFixed(2) + "K";
    } else if (num >= 10000) {
        return (num / 10000).toFixed(2) + "W";
    } else {
        return num.toString();
    }
};

//查询是否设置密码
export const handleSelectHasPayPassword = async () => {
    var res = await selectHasPayPassword();
    if (!res) {
        ElMessageBox.confirm(
            "您还未设置支付密码,为了不影响体验,请先去设置",
            "提示",
            {
                confirmButtonText: "去设置",
                cancelButtonText: "再等等",
                type: "warning",
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
            }
        )
            .then(() => {
                window.location.replace("/matchweb/layout/setpaypwd")
            })
            .catch(() => { });
    }
    return res;
}

//是否认证
export const isPassAuth = async (path, router) => {
  var { identityAuth, companyAuth } =
        await selectCustomerAuth();
    if (!identityAuth || !companyAuth) {
        ElMessageBox.alert('请先认证完成后再发货', '', {
            confirmButtonText: '去认证',
            showClose: false,
            callback: (action) => {
                if (action == 'confirm') {
                    router.push({ path: "/layout/auth" })
                }
            },
        })

    } else {
        router.push({ path })
    }
}




//导出
export const exportFile = (data, fileName) => {
    const blob = new Blob([data], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}${new Date().getTime()}.xls`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
/**
   * 获取一个月有多少天
   */
export const getDayCounts = (month) => {
    var year = new Date().getFullYear();
    var end = 0;
    if (month == 1) {
        end = 31;
    } else if (month == 2) {
        if ((year % 4 == 0) && (year % 100 != 0) || (year % 400 == 0)) {
            end = 29;
        } else {
            end = 28;
        }
    } else if (month == 3) {
        end = 31;
    } else if (month == 4) {
        end = 30;
    } else if (month == 5) {
        end = 31;
    } else if (month == 6) {
        end = 30;
    } else if (month == 7) {
        end = 31;
    } else if (month == 8) {
        end = 31;
    } else if (month == 9) {
        end = 30;
    } else if (month == 10) {
        end = 31;
    } else if (month == 11) {
        end = 30;
    } else if (month == 12) {
        end = 31;
    }

    return end;
}


//计算实付费用  旧 承运人运费*（1+税费率）+承运人运费 * 服务费点
//计算实付费用  新 运费*（1+服务费率）*（1+发票税点）
export const actualCost = (unitPrice, rate, serviceRate) => {
    // return ((((unitPrice * (1 + rate)) + (unitPrice * serviceRate)) * 100).toFixed(0)) / 100
    return (((unitPrice * (1 + serviceRate)) * (1 + rate)) * 100).toFixed(0) / 100
}

//实付总额
export const actualTotalAmountValue = (unitPrice, nowInvoiceFee, serviceRate) => {
    return ((((unitPrice + nowInvoiceFee) + (unitPrice * serviceRate)) * 100).toFixed(0)) / 100
}

//英文括号替换中文括号
export const convertAllParentheses = (text) => {
    return text.replace(/[()]/g, function (match) {
        return match === '(' ? '（' : '）';
    });
}

//加法
export const floatAdd = (arg1, arg2) => {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
}

//减    
export const floatSub = (arg1, arg2) => {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    //动态控制精度长度    
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
}